<template>
  <v-dialog :value="value" max-width="1280" scrollable @input="$emit('input', $event)">
    <v-card class="forma-erp ip">

      <div class="ip-traka">
        <div>
          <div class="ip-naslov">Prijedlog knjiženja izvoda <span v-if="izvod.broj">br. {{ izvod.broj }}</span></div>
          <div class="ip-meta">
            <span class="ip-nacrt">NACRT</span>
            ništa nije proknjiženo dok ne potvrdite odabrane stavke
          </div>
        </div>
        <div class="ip-brojke">
          <div><b>{{ stavke.length }}</b><span>neproknjiženo</span></div>
          <div><b>{{ sazetak.visoka + sazetak.srednja }}</b><span>spremno</span></div>
          <div><b>{{ sazetak.rucno }}</b><span>ručno</span></div>
          <div class="ip-istaknuto"><b>{{ odabranih.length }}</b><span>odabrano · {{ formatPrice(zbrojOdabranih) }}</span></div>
        </div>
        <v-btn icon dark aria-label="Zatvori" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-card-text class="ip-tijelo">
        <div v-if="greska" class="ip-greska" role="alert">{{ greska }}</div>
        <v-progress-linear v-if="!ucitano && !greska" indeterminate color="primary"></v-progress-linear>

        <template v-if="ucitano">
          <div v-if="izvod.vecProknjizeno || djelomicno.length" class="ip-napomena">
            <span v-if="izvod.vecProknjizeno">Već proknjiženo stavki: <b>{{ izvod.vecProknjizeno }}</b>. </span>
            <span v-if="djelomicno.length">
              Djelomično proknjižene stavke (nisu u prijedlogu, dovršite ih ručno):
              <b v-for="(d, i) in djelomicno" :key="d.id">{{ i ? ', ' : '' }}{{ d.rbr }}</b>.
            </span>
          </div>

          <div v-if="stavke.length === 0" class="ip-prazno">Na ovom izvodu nema neproknjiženih stavki.</div>

          <!-- spremno -->
          <div v-if="spremne.length" class="ip-kartica">
            <div class="naslov-kartice">
              Spremno za potvrdu <span class="ip-pod">zadnja 3 do 5 knjiženja ista · {{ spremne.length }}</span>
              <span class="ip-alat">
                <a href="#" @click.prevent="oznaci(spremne, true)">označi sve</a>
                <a href="#" @click.prevent="oznaci(spremne, false)">odznači</a>
              </span>
            </div>
            <div class="ip-scroll">
              <table class="ip-tbl">
                <thead><tr>
                  <th class="c"><span class="ip-sr">Odabir</span></th>
                  <th>R.br.</th><th>Partner i opis</th><th class="d">Iznos</th><th class="c">D/P</th>
                  <th>Konto protustrane</th><th>Sigurnost</th>
                </tr></thead>
                <tbody>
                  <tr v-for="s in spremne" :key="s.sideId" :class="{'ip-izmijenjeno': izmijenjeno(s)}">
                    <td class="c"><input type="checkbox" :checked="!!odabrano[s.sideId]" :disabled="!s.unos" :aria-label="'Odaberi stavku ' + s.rbr" @change="prebaci(s)"></td>
                    <td>{{ s.rbr }}</td>
                    <td class="opis"><b>{{ s.partner.naziv || '(bez partnera)' }}</b><small>{{ s.opis }}</small></td>
                    <td class="d">{{ formatPrice(s.iznos) }}</td>
                    <td class="c">{{ s.strana }}</td>
                    <td class="konto">
                      <v-autocomplete v-model="s.unos" :items="konta" item-value="account4" :item-text="kontoTekst"
                                      dense hide-details solo flat outlined clearable @change="promijenjen(s)"></v-autocomplete>
                      <small v-if="izmijenjeno(s)" class="ip-uputa">predloženo {{ s.konto }}</small>
                    </td>
                    <td class="razlog">
                      <span class="ip-cip" :class="'ip-' + s.razina">{{ s.razina }} · {{ s.slaganje }} od {{ s.odN }}</span>
                      <small>{{ s.razlog }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- ručno -->
          <div v-if="rucne.length" class="ip-kartica">
            <div class="naslov-kartice">
              Traži ručni odabir konta <span class="ip-pod">premalo povijesti, razilazi se ili je predujam/storno/strana valuta · {{ rucne.length }}</span>
              <span class="ip-alat"><a href="#" @click.prevent="rucnoOtvoreno = !rucnoOtvoreno">{{ rucnoOtvoreno ? 'sklopi' : 'prikaži' }}</a></span>
            </div>
            <div v-show="rucnoOtvoreno" class="ip-scroll">
              <table class="ip-tbl">
                <thead><tr>
                  <th class="c"><span class="ip-sr">Odabir</span></th>
                  <th>R.br.</th><th>Partner i opis</th><th class="d">Iznos</th><th class="c">D/P</th>
                  <th>Konto protustrane</th><th>Zašto ručno</th>
                </tr></thead>
                <tbody>
                  <tr v-for="s in rucne" :key="s.sideId">
                    <td class="c"><input type="checkbox" :checked="!!odabrano[s.sideId]" :disabled="!s.unos" :aria-label="'Odaberi stavku ' + s.rbr" @change="prebaci(s)"></td>
                    <td>{{ s.rbr }}</td>
                    <td class="opis"><b>{{ s.partner.naziv || '(bez partnera)' }}</b><small>{{ s.opis }}</small></td>
                    <td class="d">{{ formatPrice(s.iznos) }}</td>
                    <td class="c">{{ s.strana }}</td>
                    <td class="konto">
                      <v-autocomplete v-model="s.unos" :items="konta" item-value="account4" :item-text="kontoTekst"
                                      dense hide-details solo flat outlined clearable placeholder="odaberi konto" @change="promijenjen(s)"></v-autocomplete>
                    </td>
                    <td class="razlog"><small>{{ s.razlog }}</small></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="rezultat" class="ip-rezultat">
            <div class="ip-rezultat-naslov">Proknjiženo {{ rezultat.proknjizeno.length }}, preskočeno {{ rezultat.preskoceno.length }}</div>
            <div v-if="rezultat.izvod && rezultat.izvod.upozorenje" class="ip-greska">{{ rezultat.izvod.upozorenje }}</div>
            <div v-else-if="rezultat.izvod && rezultat.izvod.redakBanke">Dodan je zbirni redak banke; razlika izvoda: {{ formatPrice(rezultat.izvod.DiffTotal) }}.</div>
            <ul v-if="rezultat.preskoceno.length" class="ip-popis">
              <li v-for="p in rezultat.preskoceno" :key="'p' + p.sideId">stavka {{ p.sideId }}: {{ p.razlog }}</li>
            </ul>
          </div>
        </template>
      </v-card-text>

      <v-card-actions class="ip-podnozje">
        <v-btn color="primary" :disabled="odabranih.length === 0 || radi" :loading="radi" @click="potvrdi">
          Potvrdi odabrane ({{ odabranih.length }})
        </v-btn>
        <v-btn text @click="ucitaj">Osvježi prijedlog</v-btn>
        <span class="ip-biljeska">
          Potvrda knjiži odabrane stavke na odabrani konto. Uplate ostaju nepovezane s računima dok ih ne povežete na ekranu
          zatvaranja.
        </span>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Zatvori</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Nacrt knjizenja stavki izvoda. Server racuna prijedlog iz knjizenja prijasnjih
// izvoda (GET, samo citanje); izmjene konta ostaju ovdje u pregledniku, a stvarni
// retci glavne knjige nastaju tek na "Potvrdi odabrane".

import MainLedgerIzvodKnjizenjeService from '@/services/MainLedgerIzvodKnjizenjeService'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'

const poruka = (err) => {
  if (err && err.response && err.response.data && err.response.data.error) { return err.response.data.error }
  return err && err.message ? err.message : String(err)
}

export default {
  name: 'MainLedgerIzvodPrijedlog',
  props: {
    value: {type: Boolean, default: false}
  },
  data () {
    return {
      ucitano: false,
      greska: '',
      izvod: {},
      stavke: [],
      sazetak: {visoka: 0, srednja: 0, rucno: 0, ukupno: 0},
      konta: [],
      djelomicno: [],
      odabrano: {},
      rucnoOtvoreno: true,
      radi: false,
      rezultat: null
    }
  },
  computed: {
    spremne () { return this.stavke.filter(s => s.razina !== 'rucno') },
    rucne () { return this.stavke.filter(s => s.razina === 'rucno') },
    odabranih () { return this.stavke.filter(s => this.odabrano[s.sideId] && s.unos) },
    zbrojOdabranih () { return this.odabranih.reduce((a, s) => a + s.iznos, 0) }
  },
  watch: {
    value (otvoreno) {
      if (otvoreno) { this.ucitaj() }
    }
  },
  mounted () {
    if (this.value) { this.ucitaj() }
  },
  methods: {
    formatPrice (value) {
      const n = parseFloat(value)
      return (isNaN(n) ? 0 : n).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    kontoTekst (k) {
      return k.account4 + ' ' + (k.naziv || '')
    },
    izmijenjeno (s) {
      return !!s.konto && s.unos !== s.konto
    },
    async ucitaj () {
      this.ucitano = false
      this.greska = ''
      try {
        const {data} = await MainLedgerIzvodKnjizenjeService.prijedlog({
          CompanyId: this.$store.state.companyid,
          MainLedgerId: this.$store.state.mainledgerid
        })
        this.izvod = {...data.izvod, vecProknjizeno: data.vecProknjizeno}
        this.sazetak = data.sazetak
        this.konta = data.konta || []
        this.djelomicno = data.djelomicno || []
        // `unos` je konto koji korisnik vidi i mijenja; `konto` ostaje onaj sto je server predlozio.
        this.stavke = (data.stavke || []).map(s => ({...s, unos: s.konto || null}))
        // Predodabrane su samo sigurne - ručne korisnik označava sam, kad izabere konto.
        const novo = {}
        this.stavke.forEach(s => { if (s.razina !== 'rucno' && s.unos) { novo[s.sideId] = true } })
        this.odabrano = novo
      } catch (err) {
        this.greska = 'Prijedlog nije učitan: ' + poruka(err)
      }
      this.ucitano = true
    },
    prebaci (s) {
      this.$set(this.odabrano, s.sideId, !this.odabrano[s.sideId])
    },
    oznaci (lista, stanje) {
      lista.forEach(s => { this.$set(this.odabrano, s.sideId, stanje && !!s.unos) })
    },
    promijenjen (s) {
      // Obrisan konto ne smije ostati odabran.
      if (!s.unos) { this.$set(this.odabrano, s.sideId, false) }
    },
    async potvrdi () {
      const odabrane = this.odabranih
      if (odabrane.length === 0) { return }
      const izvanPrijedloga = odabrane.filter(s => s.razina === 'rucno').length
      const poruka1 = 'Proknjižiti ' + odabrane.length + ' stavki u iznosu ' + this.formatPrice(this.zbrojOdabranih) + '?' +
        (izvanPrijedloga ? '\n\nOd toga ' + izvanPrijedloga + ' nije označeno sigurnima.' : '')
      if (!window.confirm(poruka1)) { return }
      this.radi = true
      try {
        const {data} = await MainLedgerIzvodKnjizenjeService.potvrdi({
          CompanyId: this.$store.state.companyid,
          MainLedgerId: this.$store.state.mainledgerid,
          stavke: odabrane.map(s => ({sideId: s.sideId, konto: s.unos}))
        })
        const rez = {proknjizeno: data.proknjizeno || [], preskoceno: data.preskoceno || [], izvod: data.izvod}
        await this.osvjeziIzvod()
        this.$emit('potvrdjeno', rez)
        await this.ucitaj()
        this.rezultat = rez
      } catch (err) {
        this.greska = 'Knjiženje nije izvršeno: ' + poruka(err)
      }
      this.radi = false
    },
    // Glava i retci izvoda u storeu moraju pokazati ono sto je upravo upisano.
    async osvjeziIzvod () {
      const id = this.$store.state.mainledgerid
      try {
        const glava = (await MainLedgerService.show(id)).data.mainLedger
        const retci = (await MainLedgerDetailService.index(id)).data.mainledgerDetails
        await this.$store.dispatch('setMainLedgerActiv', glava || {})
        await this.$store.dispatch('setMainLedgerItems', retci || [])
      } catch (err) {
        // prikaz izvoda se osvjezi pri sljedecem otvaranju; knjizenje je vec spremljeno
      }
    }
  }
}
</script>

<style scoped>
.ip { display: flex; flex-direction: column; max-height: 92vh; }
.ip-traka { display: flex; align-items: center; gap: 24px; padding: 12px 20px; background: #1565c0; color: #fff; }
.ip-naslov { font-size: 20px; font-weight: 700; }
.ip-meta { font-size: 13.5px; opacity: .92; margin-top: 2px; }
.ip-nacrt { display: inline-block; padding: 0 7px; margin-right: 6px; border: 1px solid #fff; border-radius: 2px; font-weight: 700; font-size: 12px; letter-spacing: .06em; }
.ip-brojke { display: flex; gap: 22px; margin-left: auto; }
.ip-brojke div { display: flex; flex-direction: column; align-items: flex-end; line-height: 1.2; }
.ip-brojke b { font-size: 20px; }
.ip-brojke span { font-size: 12px; opacity: .88; }
.ip-istaknuto b { color: #ffe082; }
.ip-tijelo { padding: 12px 20px 4px !important; }
.ip-kartica { border: 1px solid #c7d6e6; margin: 0 0 14px; background: #fff; }
.ip-pod { font-size: 13px; font-weight: 400; color: #4a6a8a; padding-left: 10px; }
.ip-alat { float: right; font-size: 13.5px; font-weight: 400; }
.ip-alat a { margin-left: 14px; color: #1565c0; }
.ip-scroll { overflow-x: auto; }
.ip-tbl { width: 100%; border-collapse: collapse; font-size: 14px; }
.ip-tbl th { text-align: left; font-weight: 600; padding: 6px 8px; border-bottom: 1px solid #c7cfcb; color: #4a524f; white-space: nowrap; }
.ip-tbl td { padding: 5px 8px; border-bottom: 1px solid #e6ebe8; vertical-align: top; }
.ip-tbl .c { text-align: center; width: 36px; }
.ip-tbl .d { text-align: right; white-space: nowrap; }
.ip-tbl td.opis { max-width: 340px; }
.ip-tbl td.opis small, .ip-tbl td.razlog small { display: block; color: #79827e; font-size: 12px; line-height: 1.35; }
.ip-tbl td.konto { min-width: 250px; width: 280px; }
.ip-tbl td.razlog { max-width: 360px; }
.ip-uputa { color: #8c5a1e; font-size: 12px; }
.ip-izmijenjeno td { background: #fbf3e6; }
.ip-cip { display: inline-block; padding: 1px 6px; border: 1px solid #c7cfcb; border-radius: 2px; font-size: 12px; font-weight: 600; white-space: nowrap; }
.ip-visoka { border-color: #9dc3ad; background: #eaf3ee; color: #1f6b43; }
.ip-srednja { border-color: #c9d6a6; background: #f4f7e6; color: #5d6b1f; }
.ip-sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); }
.ip-prazno { padding: 24px; text-align: center; color: #79827e; }
.ip-napomena { margin: 0 0 10px; padding: 8px 12px; background: #eef4fb; border: 1px solid #c7d6e6; font-size: 14px; }
.ip-greska { margin: 8px 0; padding: 8px 12px; border: 1px solid #e0b4a8; background: #fbeeea; color: #8c2f1e; }
.ip-podnozje { gap: 8px; padding: 10px 20px; border-top: 1px solid #c7cfcb; flex-wrap: wrap; }
.ip-biljeska { color: #79827e; font-size: 13px; max-width: 60ch; }
.ip-rezultat { padding: 6px 0 10px; }
.ip-rezultat-naslov { font-weight: 600; }
.ip-popis { margin: 6px 0 0; padding-left: 18px; font-size: 13px; color: #4a524f; }
</style>
